import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]
  static values = {
    original: String,
    tracked: Boolean,
  }

  connect() {
    this.trackedValue = false
  }

  trackEdit() {
    if (this.trackedValue) return

    const currentText = this.contentTarget.value
    const originalText = this.originalValue

    const editPercentage = this.calculateEditPercentage(originalText, currentText)

    if (editPercentage > 30) {
      this.trackedValue = true

      // Track event in PostHog
      if (window.posthog) {
        window.posthog.capture("message_edited_significantly", {
          edit_percentage: editPercentage,
          message_id: this.element.dataset.messageId,
        })
      }
    }
  }

  calculateEditPercentage(original, current) {
    if (!original) return 100

    // Simple difference calculation based on character length
    const maxLength = Math.max(original.length, current.length)
    let differences = 0

    for (let i = 0; i < maxLength; i++) {
      if (original[i] !== current[i]) {
        differences++
      }
    }

    return (differences / original.length) * 100
  }
}
